import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Col, Row } from 'antd';
import Box from 'ui-box';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

const shouldNavigateOnTheAdditionalPage = (path, userAnswer) =>
  path && userAnswer === true;

function MobilePregnantNavBtn({
  fieldName,
  isFirst,
  isLast,
  prevRoutePath,
  nextRoutePath,
  additionalRoute,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const { values, submitForm } = useFormikContext();

  const value = values[fieldName];

  const onPrev = () => {
    history.push(prevRoutePath);
  };

  const onNext = () => {
    if (isLast && !shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      submitForm();
    } else if (shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      history.push(additionalRoute);
    } else {
      history.push(nextRoutePath);
    }
    // else if (shouldNavigateOnTheRecommendedGreenPage(recommendedRoute, values)) {
    //   submitForm();
    // }

  };
  let isDisabled = true;
  if (Array.isArray(value)) {
    isDisabled = value.length;
  } else if (typeof value === 'string') {
    isDisabled = value;
  } else if (typeof value === 'number') {
    isDisabled = value >= 0;
  } else if (typeof value === 'boolean') {
    isDisabled = true
  } else if (value === null) {
    isDisabled = false
  }

  return (
    <>
      <Box height="100px" marginBottom="50px" />
      <Box
        position="absolute"
        bottom="50px"
        marginLeft="auto"
        marginRight="auto"
        left="0"
        right="0"
        width="100%"
        maxWidth="480px"
        paddingX={20}
      >
        <Row gutter={16} justify="space-between">
          {
            !isFirst && (
              <Col xs={12}>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onPrev}
                  block
                  ghost
                >
                  <ArrowLeftOutlined style={{ color: '#15A9E1', marginRight: 10 }} /> {t(`common:button.previous`)}
                </Button>
              </Col>
            )
          }
          <Col xs={isFirst ? 24 : 12}>
            <Button
              htmlType="button"
              type="primary"
              size="large"
              onClick={onNext}
              disabled={!isDisabled || (values.AnyExamination && value.length === 0)}
              block
            >
              {t(`common:button.next`)} <ArrowRightOutlined style={{ color: '#FFFFFF', marginLeft: 10 }} />
            </Button>
          </Col>
        </Row>
      </Box>
    </>
  );
}

MobilePregnantNavBtn.defaultProps = {
  isLast: false,
  isFirst: false
};

const { string, bool } = PropTypes;

MobilePregnantNavBtn.propTypes = {
  fieldName: string.isRequired,
  isFirst: bool,
  isLast: bool,
  prevRoutePath: string.isRequired,
  nextRoutePath: string.isRequired,
  additionalRoute: string
};

export default MobilePregnantNavBtn;
